// extracted by mini-css-extract-plugin
export default {"top":"Header_top__MI7NN","inner":"Header_inner__tSw2n","title":"Header_title__J0AGe","subhead":"Header_subhead__A0Rpd","spacer":"Header_spacer__F3YYY"};